import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useStore } from '../../zustand';
// Helpers
import { sendAnalyticsData } from "../../utility/handleAnalytics";
import { setARCartURL, _setCustomBannerURL } from "../../utility/helpers";
// Icons
import { ReactComponent as Rotate360 } from "../../assets/icons/rotate360.svg"
import { ReactComponent as MySvg } from '../../assets/icons/ar_logo.svg';
// Variables
const BUCKET_URL = process.env.REACT_APP_BUCKET_URL_AR;

// Styles
const useStyles = makeStyles((theme) => ({
    button_container_default: {
        width: '100%',
        display: 'flex',
        justifyContent: props => props.mobile_ar_button.button_position,
        '& button': {
            ...theme.default_button,
            boxShadow: 'none',
            borderRadius: 12,
            justifyContent: 'center',
            background: props => props.mobile_ar_button.button_color,
            color: props => props.mobile_ar_button.button_text_color,
            fontFamily: props => props.default_text_font
        },
    },
    button_container_billboard: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        '& button': {
            ...theme.default_button,
            boxShadow: 'none',
            borderRadius: 12,
            justifyContent: 'center',
            flexDirection: 'column',
            background: props => props.mobile_ar_button.button_color,
            color: props => props.mobile_ar_button.button_text_color,
            fontFamily: props => props.default_text_font
        },
    },
    button_container_tabs: {
        position: 'absolute',
        top: '90%',
        right: '0.5rem',
        '& button': {
            ...theme.default_button,
            boxShadow: 'none',
            borderRadius: 12,
            justifyContent: 'center',
            //background: props => props.viewer_button.button_color,
            background: '#00344E',
            //color: props => props.viewer_button.button_text_color,
            color: '#ffffff',
            fontFamily: props => props.default_text_font,
        },
    },
    button_ar_default: {
        width: 23, 
        marginRight: 10,
        fill: props => props.viewer_button.button_color,
    },
    button_ar_icon_billboard: {
        maxWidth: '45px !important',
        fill: "#ffffff",
    },
    button_ar_default_png: {
        width: '100%',
        maxWidth: 23,
        marginRight: 10,
    },
    button_ar_tabs: {
        width: 18, 
        marginRight: 10,
        //fill: props => props.viewer_button.button_color,
        fill: '#ffffff',
    },
    btn_from_modal: {
        ...theme.default_button,
        textTransform: 'uppercase',
        padding: '10px 15px 10px',
        justifyContent: 'center',
        width: '100%',
        background: props => props.viewer_button.button_color,
        color: props => props.viewer_button.button_text_color,
        fontFamily: props => props.default_text_font,
        margin: 'auto'
    },
    loaderSpinner: {
        border: '2px solid #ffffff',
        borderTopColor: props => props.viewer_button.button_color,
        borderTop: '2px solid',
        borderRadius: '50%',
        width: 16,
        height: 16,
        animation: '$spin .6s linear infinite'
    },
    iconContainer: {
        display: 'flex',
        '& button': {
            transition: 'all 0.5s ease',
            opacity: 1,
            padding: 0,
            border: 'none',
            outline: 'none',
            background: 'none',
            cursor: 'pointer',
            '&:hover': {
                opacity: .5
            },
        }
    },
    rotate_360_icon: {
        width: 60,
        '& .cls-1': {
            fill: '#bdbec0',
        },
    },
    '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' }
    }
}));

export default function BtnLaunchAR(props) {
    const { button_type } = props;
    const [loading, setLoading] = React.useState(false);
    const { intent, target } = useStore.getState().hrx;
    const variant_id = useStore(state => state.variant_id);
    const { store_id, vList } = useStore.getState().variants_payload;
    const { variant_type, viewer_type, ar_activation } = useStore.getState().settings;
    const actions = useStore(state => state.actions);
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);
    
    const custom_banner = true;

    const _handleLaunchAR = async (e) => {
        e.preventDefault();

        if (intent === 'canQL' || intent === 'canSV') {
            actions.handleModalDisplay({ display: 'RedirectPrompt', status: true });
            return;
        }
        // if ar_activation is true from params and is iphone aka HANK
        if(ar_activation && intent === 'willQL') {
            actions.handleModalDisplay({ display: 'ArActivation', status: true });
            return;
        }

        // TODO: Check Ipad post message close?
        if (target === 'iPadQL' || target === 'iPadNQL' || target === 'iPadLiteNQL') {
            window.parent.postMessage('iPadExit', '*');
        };

        setLoading(true);
        await sendAnalyticsData({ event_type: 'view_ar_launch' });

        let anchor = document.getElementById("ar-link");
        
        if(!anchor) {
            anchor = document.createElement('a');
            anchor.setAttribute('id', 'ar-link') 
            anchor.setAttribute('rel', 'ar');
            anchor.appendChild(document.createElement('img'));
            
            document.body.appendChild(anchor)

            if(custom_banner && (intent === 'willQL')) {
                const qlBannerLink = setARCartURL(variant_id, vList, variant_type)
                anchor.addEventListener("message", async function (event) {
                    // eslint-disable-next-line
                    if (event.data == "_apple_ar_quicklook_button_tapped") {
                        await sendAnalyticsData({ event_type: 'cart_ar_add' });
                        if(viewer_type === "levar_debut"){
                            console.log("its debut attempting to close the viewer")
                            window.parent.postMessage('levarViewerClose', '*');
                        } else {
                            setTimeout(function(){
                                window.location.href = qlBannerLink
                            }, 100);
                        }
                    }
                }, false);
            }
        }

        let updatedUrl = handleViewerUrl();
        anchor.setAttribute('href', updatedUrl);

        // anchor.click();

        setTimeout(() => {  
            setLoading(false);
        }, 1000);
    };

    const handleViewerUrl = () => {
        let finalUrl = "";

        if(intent === 'willQL') {
            
            const dt = `${BUCKET_URL}${store_id}/${vList[variant_id].bundle}/${vList[variant_id].ardt}.usdz`;
            const scalingOn = '#allowsContentScaling=0';
            const custom_cta = custom_banner ? _setCustomBannerURL(variant_id, variant_type) : ""
            
            finalUrl = `${dt}${scalingOn}${custom_cta}`;
            console.log('finalUrl::', finalUrl)
        } else if(intent === 'willSV') {
            let levar_intent = "ar_preferred" // Intent
            let browser_fallback_url = "https://developers.google.com/ar;" // if Google Play Services for AR isn't present, Scene Viewer launches the URL you set in the
            let package_scene = "com.google.android.googlequicksearchbox"; // ar_only => com.google.ar.core
            
            let glbURL = `${BUCKET_URL}${store_id}/${vList[variant_id].bundle}/${vList[variant_id].ardt}.glb`; // GLB URL

            let sceneURL = `#Intent;scheme=https;package=${package_scene};action=android.intent.action.VIEW;S.browser_fallback_url=${browser_fallback_url}`
            finalUrl = `intent://arvr.google.com/scene-viewer/1.1?file=${glbURL}&mode=${levar_intent}&resizable=false${sceneURL}end;`; // v 1.1                        
        }

        return finalUrl;
    };

    switch(button_type) {
        case 'modal':
            return (
                <button onClick={(e) => _handleLaunchAR(e)} className={classes.btn_from_modal}>
                    { !loading ? 'View in my space' : <div className={classes.loaderSpinner}></div> }
                </button>
            );
        case 'rotate_icon':
            return (
                <div className={classes.iconContainer}>
                    <button onClick={(e) => _handleLaunchAR(e)}>
                        { !loading ? <Rotate360 className={classes.rotate_360_icon} /> : <div className={classes.loaderSpinner}></div> }
                    </button>
                </div>
            )
        case 'billboard':
            return (
                <div className={classes.button_container_billboard}>
                    <button onClick={(e) => _handleLaunchAR(e)}>
                        { !loading ? <>See in AR</> : <div className={classes.loaderSpinner}></div> }
                        <MySvg className={classes.button_ar_icon_billboard} /> 
                    </button>
                </div>
            );
        case 'tabs':
            return (
                <div className={classes.button_container_tabs}>
                    <button onClick={(e) => _handleLaunchAR(e)}>
                        <MySvg className={classes.button_ar_tabs} />
                        { !loading ? <>My Space</> : <div className={classes.loaderSpinner}></div> }
                    </button>
                </div>
            );
        default:
            return (
                <div className={classes.button_container_default}>
                    <button onClick={(e) => _handleLaunchAR(e)}>
                        <MySvg className={classes.button_ar_tabs} />
                        { 
                        !loading ? 
                        <>{dynamic_text_settings.mobile_ar_button.button_text}</> : 
                        <div className={classes.loaderSpinner}></div> }     
                    </button>
                </div>
            );
    }
}